<template>
    <b-row class="mt-4" v-if="showQuadrants">
        <section-slot sectionIcon="fas fa-th" :section="$t('nBox.quadrant')">
            <loader :showMessage="false" :loader="isLoading" v-if="isLoading" />
            <div v-else>
                <div class="p-2" :key="result.quadrant.id" v-for="result in orderedResults">
                    <div class="n_box_title">{{ result.n_box.title }}</div>
                    <div class="quadrant">
                        <div v-show="result.quadrant.title" class="quadrant__title">
                            <span> {{ result.quadrant.title }}</span>
                        </div>
                        <div v-if="result.n_box.calibration_type == 'score'" class="quadrant__info">
                            <div v-if="result.scores.x !== null">
                                <span>{{ result.n_box.title_x }}:&nbsp;</span>
                                <strong>{{ formatNumber(result.scores.x) }}</strong>
                            </div>
                            <div v-if="result.scores.y !== null">
                                <span>{{ result.n_box.title_y }}:&nbsp;</span>
                                <strong>{{ formatNumber(result.scores.y) }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section-slot>
    </b-row>
</template>
<script>
import { orderBy } from 'lodash'
import { getUserQuadrants } from './api'
import SectionSlot from '../section-slot'
import Loader from '@/views/components/loader'
import { userPermissionsMixin } from '@/mixins'
import { formatNumber, decimalFormat } from '@/lib/utils'

export default {
    name: 'Quadrants',
    mixins: [userPermissionsMixin],
    components: {
        Loader,
        SectionSlot,
    },
    props: {
        periods: {
            type: Array,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            results: [],
            isLoading: true,
        }
    },
    mounted() {
        this.getUserQuadrants()
    },
    methods: {
        getUserQuadrants() {
            this.isLoading = true
            return getUserQuadrants(this.user.id)
                .then((data) => {
                    this.results = data
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        formatNumber(value) {
            return formatNumber(decimalFormat(value))
        },
    },
    computed: {
        orderedResults() {
            return orderBy(this.results, 'n_box.calibration_type')
        },
        currentUser() {
            return this.$store.state.currentUser.user
        },
        canViewQuadrant() {
            return this.canViewEvaluations
        },
        canViewEvaluations() {
            return this.canViewUserEvaluationsResults(this.currentUser, this.user)
        },
        showQuadrants() {
            if (!this.canViewEvaluations) {
                return false
            }

            if (this.isLoading) {
                return false
            }

            return this.results.length > 0
        },
    },
    watch: {
        'user.id'(newUserID, oldUserID) {
            if (newUserID !== oldUserID) {
                this.getUserQuadrants()
            }
        },
        periods(newValue, oldValue) {
            if (newValue.length !== oldValue.length) {
                this.getUserQuadrants()
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.n_box_title {
    font-weight: bold;
    margin-bottom: 0.25rem;
}

.quadrant {
    display: flex;
    flex-direction: column;
}

.quadrant__title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
    padding: 4px;
    border-radius: 5px;
    color: #009bdb;
    text-align: center;
    font-weight: bold;
    background: #ebebeb;
}

.quadrant__info {
    display: flex;
    flex-direction: column;
}
</style>
